export const CITY_SEARCH_QUERY_MIN_LENGTH = 3;
export const CITY_SEARCH_QUERY_FORM_NAME = 'citySearchQuery' as const;
